// The whole of this app's shared state. Small enough for a reactive object,
// no Vuex. Shaped `{ state: {...} }` because the house bug-report module
// reads `store.state`, which keeps that file recognisably the same one
// Meal Hat, Movie Hat and Cinema Roll carry.
import { reactive } from 'vue';

export const store = reactive({
  state: {
    updateAvailable: false,
    appError: null,
    email: null,
    // Which hat the course is attached to (Meal Hat's database top key).
    hat: null,
    // What the person is doing, for a bug report to say so: 'home', 'lesson',
    // 'cooking', 'debrief'.
    activity: 'home',
    // Where they are, for the teacher (TeacherChat.vue): every screen sets
    // it as it mounts; cook mode keeps phase and step current.
    where: { screen: 'home', lessonId: null, phase: null, stepIndex: 0 },
    // The household's app preferences (<hat>/cooking/preferences), which
    // the teacher can change. Applied in App.vue.
    preferences: {},
    // The ThermoMaven probe, while cook mode is open (utils/probe.js):
    // { meat, ambient, target, at, readAt } or null; `unavailable` once the
    // server says this household has no probe.
    probe: null,
    // A one-shot command from the teacher to whichever screen is listening
    // (go_to_step → CookScreen). `at` makes each one distinct.
    command: null
  }
});

export const setUpdateAvailable = (value) => { store.state.updateAvailable = value; };
export const setAppError = (message) => { store.state.appError = message; };
export const setEmail = (email) => { store.state.email = email || null; };
export const setHat = (hat) => { store.state.hat = hat || null; };
export const setActivity = (activity) => { store.state.activity = activity; };
export const setWhere = (partial) => { store.state.where = { ...store.state.where, ...partial }; };
export const setPreferences = (prefs) => { store.state.preferences = prefs || {}; };
export const setProbe = (probe) => { store.state.probe = probe; };
export const sendCommand = (command) => { store.state.command = { ...command, at: Date.now() }; };
